import { render, staticRenderFns } from "./PeopleIndex.vue?vue&type=template&id=672309ee&scoped=true&"
import script from "./PeopleIndex.vue?vue&type=script&lang=js&"
export * from "./PeopleIndex.vue?vue&type=script&lang=js&"
import style0 from "./PeopleIndex.vue?vue&type=style&index=0&id=672309ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672309ee",
  null
  
)

export default component.exports